import { render, staticRenderFns } from "./CampaignPointsForm.vue?vue&type=template&id=731fe064&scoped=true&"
import script from "./CampaignPointsForm.vue?vue&type=script&lang=js&"
export * from "./CampaignPointsForm.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPointsForm.vue?vue&type=style&index=0&id=731fe064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731fe064",
  null
  
)

export default component.exports